// extracted by mini-css-extract-plugin
module.exports = {"STARCTypography":"az_J_b"};